<template>
	<div class="full-width pa-4">
		<!-- <v-card class="pa-5"> -->
		<h5 class="headline mb-5">{{ title }}</h5>
		<v-layout>
			<v-flex xs11 sm6 lg3>
				<v-text-field
					label="Enter Parent Phone*"
					v-model="parentNumber"
					:loading="parentDataLoading"
					:rules="[requiredRule, validPhoneRule]"
					:disabled="parentDataLoading"
					clearable
				></v-text-field>
			</v-flex>
		</v-layout>
		<v-layout v-if="parentData.userType" class="mb-3 green--text">
			<v-flex xs12 sm6 lg3>
				<div class="retailer-data allCenteredChild pa-2">
					<div class="title">
						Parent Name: {{ parentData.retailerName }}
					</div>
					<div>
						Parent Role:
						{{ possibleStoreTypes[parentData.userType] }}
					</div>
				</div>
			</v-flex>
		</v-layout>
		<v-layout>
			<v-flex xs12 sm6 lg3>
				<v-text-field
					clearable
					label="Enter Child Phone*"
					v-model="childNumber"
					:loading="childDataLoading"
					:disabled="childDataLoading"
					:rules="[
						requiredRule,
						validPhoneRule,
						parentAndChildShouldBeDifferent
					]"
				></v-text-field>
			</v-flex>
		</v-layout>
		<v-layout v-if="childData.userType" class="mb-3 blue--text">
			<v-flex xs12 sm6 lg3>
				<div class="retailer-data allCenteredChild pa-2">
					<div class="title">
						Child Name: {{ childData.retailerName }}
					</div>
					<div>
						Child Role: {{ possibleStoreTypes[childData.userType] }}
					</div>
				</div>
			</v-flex>
		</v-layout>
		<v-btn
			class="mx-0 my-4 white--text"
			:color="themeInputColor"
			@click="updateMapping"
			:loading="updateMappingLoading"
			:disabled="checkDisable"
			>Update Mapping</v-btn
		>
	</div>
</template>

<script>
import { mapState } from "vuex";
import {
	UPDATE_MAPPING,
	FETCH_JEET11_PARTNER_WALLET_DETAILS,
	SHOW_ALERT
} from "@/store/action-types";

import { _validPhoneNoRule } from "@/utils";

import {
	JEET_11_PARTNER,
	JEET_11_DISTRIBUTOR,
	JEET_11_EXECUTIVE,
	JEET_11_PROMOTER
} from "@/store/config";

export default {
	name: "UpdateMappingTool",
	props: ["title", "themeInputColor"],
	data() {
		return {
			parentNumber: "",
			parentData: {},
			parentDataLoading: false,
			childNumber: "",
			childData: {},
			childDataLoading: false,
			requiredRule: v => !!v || "This is required",
			updateMappingLoading: false,
			validPhoneRule: _validPhoneNoRule,
			possibleStoreTypes: {
				dstr: JEET_11_DISTRIBUTOR,
				dstrRetail: JEET_11_PARTNER,
				executive: JEET_11_EXECUTIVE,
				promoter: JEET_11_PROMOTER
			}
		};
	},
	computed: {
		checkDisable() {
			return (
				!this.parentNumber ||
				!this.childNumber ||
				!this.childData.userType ||
				!this.parentData.userType
			);
		},
		parentAndChildShouldBeDifferent() {
			if (this.childNumber === this.parentNumber) {
				return "Parent and Child user should be different!";
			}
			return false;
		}
	},
	methods: {
		getUserData(phone, loadingKey, dataKey) {
			if (!this[loadingKey]) {
				this[loadingKey] = true;
				this.$store
					.dispatch(FETCH_JEET11_PARTNER_WALLET_DETAILS.dispatch, {
						p: Number("91" + phone)
					})
					.catch(() => {})
					.then(data => {
						this[loadingKey] = false;
						if (data.userType) {
							this[dataKey] = {
								...data
							};
						} else {
							this.showAlert("Something is not right!!");
						}
					});
			}
		},
		showAlert(text) {
			this.$store.dispatch(SHOW_ALERT.dispatch, { text });
		},
		updateMapping() {
			if (!this.updateMappingLoading) {
				if (
					this.parentData.userType === "dstr" &&
					this.childData.userType === "dstrRetail"
				) {
					this.showAlert(
						`${this.possibleStoreTypes["dstrRetail"]} cannot be mapped to ${this.possibleStoreTypes["dstr"]}`
					);
					return;
				} else if (
					this.parentData.userType === "executive" &&
					this.childData.userType === "dstr"
				) {
					this.showAlert(
						`Child cannot be ${this.possibleStoreTypes["dstr"]}`
					);
					return;
				} else if (
					this.parentData.userType === "dstrRetail" &&
					(this.childData.userType === "dstr" ||
						this.childData.userType === "executive")
				) {
					this.showAlert(
						`Parent cannot be ${this.possibleStoreTypes["dstrRetail"]}`
					);
					return;
				}
				this.updateMappingLoading = true;
				this.$store
					.dispatch(UPDATE_MAPPING.dispatch, {
						userData: [
							{
								userNumber: Number("91" + this.parentNumber),
								mapNumber: Number("91" + this.childNumber)
							}
						]
					})
					.then(() => {
						this.resetData();
					})
					.catch(() => {})
					.finally(() => {
						this.updateMappingLoading = false;
					});
			}
		},
		resetData() {
			this.parentNumber = null;
			this.parentData = {};
			this.childNumber = null;
			this.childData = {};
		}
	},
	watch: {
		parentNumber(newVal) {
			if (newVal && newVal.length === 10) {
				this.getUserData(newVal, "parentDataLoading", "parentData");
			} else {
				this.parentData = {};
			}
		},
		childNumber(newVal) {
			if (newVal && newVal.length === 10) {
				if (this.childNumber === this.parentNumber) {
					this.showAlert(
						"Parent and Child user should be different."
					);
					return;
				}
				this.getUserData(newVal, "childDataLoading", "childData");
			} else {
				this.childData = {};
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.retailer-data {
	border: 2px solid;
	border-radius: 7px;
	flex-direction: column;
}
</style>
